<div class="pt-3"></div>

<div class="row tab-container pl-2" *ngIf="!isSimplifyData">
  <div class="col-7 p-0">
    <div class="row">
      <!-- Implemeting tabs  1st tabs-->
        <!-- <div class="lbl-text align-tabs" [ngClass]="{'activeTimeLine': toggleStatus === 'taskDetails'}">
          <a (click)="toggleMode('taskDetails')"> Task Details</a>
        </div> -->
        <div [ngClass]="toggleStatus === 'taskDetails' ? 'col-3 tabNewSub p-2 activeNewTimeLine' : 'col-3 tabNewSub p-2'"
            (click)="toggleMode('taskDetails')">
          <div class="newAlignTab lbl-text align-tabs">
            <a><mat-icon>assignment</mat-icon> Task Details 
              <mat-icon *ngIf="toggleStatus === 'taskDetails'">keyboard_arrow_down</mat-icon>
            </a>
          </div>
        </div>
      <!-- 2nd tab -->
        <!-- <div class="lbl-text align-tabs drafttext" [ngClass]="{'activeTimeLine': toggleStatus === 'externalLinks'}">
            <a (click)="toggleMode('externalLinks')"> External Links</a> 
        </div> -->
        <div [ngClass]="toggleStatus === 'externalLinks' ? 'col-3 tabNewSub p-2 activeNewTimeLine' : 'col-3 tabNewSub p-2'"
            (click)="toggleMode('externalLinks')">
          <div class="newAlignTab lbl-text align-tabs">
            <a><mat-icon>launch</mat-icon> External Links 
              <mat-icon *ngIf="toggleStatus === 'externalLinks'">keyboard_arrow_down</mat-icon>
            </a>
          </div>
        </div>
      <!-- 3rd tab -->
        <!-- <div
          class="lbl-text align-tabs drafttext"
          [ngClass]="{ activeTimeLine: toggleStatus === 'requestDataDocuments' }"
        >
          <a (click)="toggleMode('requestDataDocuments')"> Request data & documents</a> 
        </div> -->
        <div *ngIf="userType !=='Beneficiary'" [ngClass]="toggleStatus === 'requestDataDocuments' ? 'col-3 tabNewSub p-2 activeNewTimeLine' : 'col-3 tabNewSub p-2'"
            (click)="toggleMode('requestDataDocuments')">
          <div class="newAlignTab lbl-text align-tabs">
            <a><mat-icon>notes</mat-icon> Request data & documents
              <mat-icon *ngIf="toggleStatus === 'requestDataDocuments'">keyboard_arrow_down</mat-icon>
            </a>
          </div>
        </div>
      <!-- 4th tab -->
        <!-- <div
          class="lbl-text align-tabs drafttext"
          [ngClass]="{ activeTimeLine: toggleStatus === 'dataLog' }"
        >
          <a (click)="toggleMode('dataLog')"> Data Log</a> 
        </div> -->
        <div *ngIf="userType !=='Beneficiary'" [ngClass]="toggleStatus === 'dataLog' ? 'col-2 tabNewSub p-2 activeNewTimeLine' : 'col-2 tabNewSub p-2'"
            (click)="toggleMode('dataLog')">
          <div class="newAlignTab lbl-text align-tabs">
            <a><mat-icon>schedule</mat-icon> Data Log 
              <mat-icon *ngIf="toggleStatus === 'dataLog'">keyboard_arrow_down</mat-icon>
            </a>
          </div>
        </div>
    </div>
  </div>
</div>
<div class="row tab-container pl-2" *ngIf="isSimplifyData">
  <!-- Implemeting tabs  1st tabs-->
  <div class="col-7 p-0">
    <div class="row">
      <!-- <div class="col-3 tab-label externel-links tab-height p-0">
        <div class="lbl-text align-tabs" [ngClass]="toggleStatus === 'taskDetails' ? 'tabNewSub activeNewTimeLine' : 'tabNewSub'" (click)="toggleMode('taskDetails')">
          <div class="newAlignTab lbl-text align-tabs">
            <a><mat-icon>assignment</mat-icon> Task Details <mat-icon *ngIf="toggleStatus === 'taskDetails'">keyboard_arrow_down</mat-icon></a>
          </div>
        </div>
      </div> -->
      <div [ngClass]="toggleStatus === 'taskDetails' ? 'col-3 tabNewSub p-2 activeNewTimeLine' : 'col-3 tabNewSub p-2'"
            (click)="toggleMode('taskDetails')">
          <div class="newAlignTab lbl-text align-tabs">
            <a><mat-icon>assignment</mat-icon> Task Details 
              <mat-icon *ngIf="toggleStatus === 'taskDetails'">keyboard_arrow_down</mat-icon>
            </a>
          </div>
        </div>
      <!-- 2nd tab -->
      <!-- <div class="col-3 tab-label externel-links tab-height p-0"> 
        <div class="lbl-text align-tabs drafttext" [ngClass]="toggleStatus === 'externalLinks' ? 'tabNewSub activeNewTimeLine' : 'tabNewSub'" (click)="toggleMode('externalLinks')">
          <div class="newAlignTab lbl-text align-tabs">
            <a><mat-icon>launch</mat-icon> External Link <mat-icon *ngIf="toggleStatus === 'externalLinks'">keyboard_arrow_down</mat-icon></a>
          </div>
        </div>
      </div> -->
      <div [ngClass]="toggleStatus === 'externalLinks' ? 'col-3 tabNewSub p-2 activeNewTimeLine' : 'col-3 tabNewSub p-2'"
            (click)="toggleMode('externalLinks')">
          <div class="newAlignTab lbl-text align-tabs">
            <a><mat-icon>launch</mat-icon> External Links 
              <mat-icon *ngIf="toggleStatus === 'externalLinks'">keyboard_arrow_down</mat-icon>
            </a>
          </div>
        </div>
      <!-- 3rd tab -->
      <!-- <div class="col-4 tab-label externel-links tab-height p-0">
        <div class="lbl-text align-tabs drafttext" [ngClass]="toggleStatus === 'requestDataDocuments' ? 'tabNewSub activeNewTimeLine' : 'tabNewSub'" (click)="toggleMode('requestDataDocuments')">
          <div class="newAlignTab lbl-text align-tabs">
            <a><mat-icon>notes</mat-icon> Request data & documents <mat-icon *ngIf="toggleStatus === 'requestDataDocuments'">keyboard_arrow_down</mat-icon></a>
          </div>
        </div>
      </div> -->
      <div *ngIf="userType !=='Beneficiary'" [ngClass]="toggleStatus === 'requestDataDocuments' ? 'col-3 tabNewSub p-2 activeNewTimeLine' : 'col-3 tabNewSub p-2'"
            (click)="toggleMode('requestDataDocuments')">
          <div class="newAlignTab lbl-text align-tabs">
            <a><mat-icon>notes</mat-icon> Request data & documents
              <mat-icon *ngIf="toggleStatus === 'requestDataDocuments'">keyboard_arrow_down</mat-icon>
            </a>
          </div>
        </div>
      <!-- 4th tab -->
      <!-- <div class="col-2 tab-label externel-links tab-height p-0">
        <div class="lbl-text align-tabs drafttext" [ngClass]="toggleStatus === 'dataLog' ? 'tabNewSub activeNewTimeLine' : 'tabNewSub'" (click)="toggleMode('dataLog')">
          <div class="newAlignTab lbl-text align-tabs">
            <a><mat-icon>schedule</mat-icon> Data Log <mat-icon *ngIf="toggleStatus === 'dataLog'">keyboard_arrow_down</mat-icon></a>
          </div>
        </div>
      </div>  -->
      <div *ngIf="userType !=='Beneficiary'" [ngClass]="toggleStatus === 'dataLog' ? 'col-2 tabNewSub p-2 activeNewTimeLine' : 'col-2 tabNewSub p-2'"
            (click)="toggleMode('dataLog')">
          <div class="newAlignTab lbl-text align-tabs">
            <a><mat-icon>schedule</mat-icon> Data Log 
              <mat-icon *ngIf="toggleStatus === 'dataLog'">keyboard_arrow_down</mat-icon>
            </a>
          </div>
        </div>
    </div>
  </div>
  
</div>
<div *ngIf="toggleStatus === 'taskDetails'" class="pt-4 pl-3">
  <img src="assets/images/summary_icon.png" height="50" alt="" width="40">
<h4 class="text-primary ml-2 d-inline">Summary</h4>
<div *ngIf="elapseTime" class="float-right">
  <mat-icon class="material-icons align-middle">watch_later</mat-icon>
  <label>Elapse Time - {{elapseTime}} days</label>
  <mat-icon matTooltip="Number of days from filing of the petition to current date."
    class="material-icons  align-middle">info</mat-icon>
</div>
<hr />

<div class="row">
  <div class="col-md-5">
    <h4 class="mb-4">Task</h4>
  </div>
  <div *ngIf="dueDays >= 0" class="col-4 mt-1 duedate summery-txt">
    <span class="duedate"*ngIf="superTaskDetails.taskDueDate !== null" class="mb-4">Task Due Date: {{taskDueDate }}({{dueDays}} days Remaining)</span>
  </div>
  <div *ngIf="dueDays < 0" class="col-4 mt-1 overduedate summery-txt">
    <span class="duedate"*ngIf="superTaskDetails.taskDueDate !== null" class="mb-4">Task Due Date: {{taskDueDate }}({{overDueDays}} days Overdue)</span>
  </div>
 
  <div class="col-md-3 d-flex summery-txt">
    <label>Status Summary</label>
    <p-inputSwitch [(ngModel)]="checkSummeryDetails"></p-inputSwitch>
  </div>
</div>

<div class="mat-elevation-z8" *ngIf="!checkSummeryDetails">
  <p-table class="p-table table d-block" styleClass="p-datatable-gridlines" [value]="summeryStepList" dataKey="id" *ngIf="summeryStepList?.length > 0" [rowHover]="true">
    <ng-template pTemplate="header" let-columns>
      <tr class="text-uppercase">
        <th style="width:70px">Status</th>
        <th colspan="2">Steps</th>
        <!-- <th>Step Actionable For</th> -->
        <th>Allocated Time</th>
        <th>Start Date</th>
        <th>End Date</th>
        <th colspan="2">Remaining</th>
        <th>Assigned To</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-expanded="expanded" let-columns="columns">
      <tr>
        <td><img *ngIf="row.completionStatus === null" src="assets/images/StepNew.svg" alt="">
          <img [ngbTooltip]="row.estimatedTime" tooltipClass="inprogress" *ngIf="row.completionStatus === 'PENDING'" src="assets/images/StepInprogress.svg" alt="">
          <img [ngbTooltip]="row.estimatedTime" tooltipClass="completed"  *ngIf="row.completionStatus === 'COMPLETED'" src="assets/images/StepSubmitted.svg" alt="">
          <img [ngbTooltip]="row.estimatedTime" tooltipClass="over-due" *ngIf="row.completionStatus === 'OVERDUE'" src="assets/images/OverDue.svg" alt="">
        </td>
        <td colspan="2">{{row.stepName}}</td>
        <!-- <td>{{row.isBeneficiaryAction === 0 ? 'Petitioner/Attorney' : 'Beneficiary'}}</td> -->
        <td>{{row.duration }}  {{  row.duration ? row.durationUnit : '--'}} </td>
        <td>{{row.stepStartDate ? (row.stepStartDate | date:'dd-MMM-yyyy') : '--'}}</td>
        <td>{{row.stepCompletionDate ? (row.stepCompletionDate | date:'dd-MMM-yyyy') : '--'}}</td>
        <td colspan="2">{{row.estimatedTime ? row.estimatedTime : '--'}}</td>
        <td *ngIf="row.isPetitionerAction === 1 || row.isAttorneyAction === 1">{{ (row.assignToEmployeeName)? row.assignToEmployeeName : '--' }}</td>
        <td *ngIf="row.isBeneficiaryAction === 1">{{ (row.assignToBeneficiaryName) ? row.assignToBeneficiaryName : (row.assignToEmployeeName)? row.assignToEmployeeName : '--'  }}</td>
      
      </tr>                                       
    </ng-template>
  </p-table>
  <div *ngIf="summeryStepList?.length == 0" class="mt-4 text-center">No Data</div>
</div>


<div class="row p-4" *ngIf="checkSummeryDetails">
  <div class="col-7 border-right">
    <!-- <h4 class="mb-4">Task</h4> -->
    <div *ngFor="let subTask of subTaskList; let i = index;" [ngClass]="{'mt-3': i > 0}">
      <div class="task-additional-details mb-3">
        <p-card>
          <div class="p-col-8 p-0">
            <h5>Additional Task / Petition Details</h5>
            <span>Task details are required for completing the petition.</span>
          </div>
          <div class="p-col-4 d-flex flex-direction-col p-0">
            <button pButton pRipple
                (click)="handleAddClick(subTask)" type="button" label="Add Details"
                class="p-button-outlined float-right" [disabled]="subTask?.statusCode === 'FILED' && subTask.isOutside !== 1"></button>
          </div>
        </p-card>
      </div>
      <p-accordion class="summary-accordion" [multiple]="true">
        <p-accordionTab [selected]="i === 0">
          <ng-template pTemplate="header">
            <img src="assets/images/petition_summary_icon.png" alt="">
            <h6 class="w-100 ml-2">
              <span>
                <span *ngIf="subTask.visaTypeName">{{ subTask?.visaTypeName }} </span>
                {{ subTask?.taskTypeName }}
              </span>
              <button pButton pRipple
                *ngIf="subTask?.visaTypeName && subTask?.taskTypeCode === 'PETITION' && subTask?.statusName === 'New'"
                (click)="onInitiateSubTask($event, subTask)" type="button" label="initiate"
                class="p-button-outlined float-right p-button-initiate mr-3"></button>
              <button pButton pRipple
                *ngIf="(subTask?.taskTypeCode === 'PWD' || subTask?.taskTypeCode === 'RECEFF' || subTask?.taskTypeCode === 'I130') && subTask?.statusName === 'New'"
                (click)="onInitiateSubTask($event, subTask)" type="button" label="initiate"
                class="p-button-outlined float-right p-button-initiate  mr-3"></button>
              <span class="float-right"
                *ngIf="!((subTask?.taskTypeCode === 'PWD' || subTask?.taskTypeCode === 'RECEFF' || subTask?.taskTypeCode === 'I130') && subTask?.statusName === 'New') && subTask?.taskTypeCode != 'RFE' && subTask?.taskTypeCode != 'PETITION'">
                {{ subTask?.statusName }}
              </span>
              <span class="float-right"
                *ngIf="subTask.taskTypeCode === 'PETITION' && !(subTask.visaTypeName && subTask.statusName === 'New')">
                <span *ngIf="subTask.isOutside == 1 && disableRfe">
                  <button (click)="onInitiateSubTask($event, subTask)" pButton type="button"
                    label=" + Add Petition Details" class="p-button-outlined p-1 h-auto"></button>
                </span>
                <span *ngIf="subTask.isOutside == 1 && !disableRfe" [class.text-filed]="subTask.statusName=='Filed'">
                  {{ subTask.statusName }}
                </span>
                <span *ngIf="subTask.isOutside == 0" [class.text-filed]="subTask.statusName=='Filed'">
                  {{ subTask.statusName }}
                </span>
              </span>
              <span class="float-right" *ngIf="subTask.taskTypeCode === 'RFE' ">
                <button *ngIf="disableRfe" (click)="onInitiateSubTask($event, subTask.taskTypeCode)" pButton
                  type="button" label="Build Response" class="p-button-outlined p-1 h-auto"></button>
                <span *ngIf="!disableRfe" [class.text-filed]="subTask.statusName=='Filed'">
                  {{ subTask.statusName
                  }}</span>
              </span>
            </h6>
          </ng-template>
          <ng-template pTemplate="content">
            <p-timeline [value]="subTask.stepOverviewList" class="summaryTimeline">
              <ng-template pTemplate="content" let-stepOverview style="height: 32px;">
                <div class="col-12 stepHeightCls d-flex">
                  <div class="col-10 alignDiv" [ngClass]="{'complete':stepOverview.stepStatusCode=='COMPLETE',
                'inprogress': stepOverview.stepStatusCode === 'INPROGRESS',
                'new':stepOverview.stepStatusCode === 'NEW',
                'submit':stepOverview.stepStatusCode === 'SUBMIT' }" pTooltip="It is a tooltip" tooltipEvent="focus">
                    <span class="icon"></span>
                    <label>{{ stepOverview.stepName }}</label>
                  </div>
                  <div class="col-4">
                    <label *ngIf="stepOverview.isPetitionerAction === 1 || stepOverview.isAttorneyAction === 1">{{ (stepOverview.assignToEmployeeName)? stepOverview.assignToEmployeeName : '--' }}</label>
                    <label *ngIf="stepOverview.isBeneficiaryAction === 1">{{ (stepOverview.assignToBeneficiaryName) ? stepOverview.assignToBeneficiaryName : (stepOverview.assignToEmployeeName)? stepOverview.assignToEmployeeName : '--' }}</label>
                    <!-- <label *ngIf="stepOverview.isBeneficiaryAction === 1">{{ superTaskDetails.beneficiaryFirstName }} {{superTaskDetails.beneficiaryLastName}}</label> -->
                  </div>
                </div>
              </ng-template>
            </p-timeline>
            <p-timeline [value]="subTask.customStepOverviewList" class="summaryTimeline">
              <ng-template pTemplate="content" let-custStepOverview style="height: 32px;">
                <div class="col-12 stepHeightCls">
                  <div class="col-10 alignDiv" [ngClass]="{'complete':custStepOverview.stepStatusCode=='COMPLETE',
                'inprogress': custStepOverview.stepStatusCode === 'INPROGRESS',
                'new':custStepOverview.stepStatusCode === 'NEW',
                'submit':custStepOverview.stepStatusCode === 'SUBMIT' }" pTooltip="It is a tooltip" tooltipEvent="focus">
                    <span class="icon"></span>
                    <label>{{ custStepOverview.stepName }}</label>
                  </div>
                  <div class="col-4 assignCls">
                    <label *ngIf="custStepOverview.isPetitionerAction === 1 || custStepOverview.isAttorneyAction === 1">{{ (custStepOverview.assignToEmployeeName)? custStepOverview.assignToEmployeeName : '--' }}</label>
                    <label *ngIf="custStepOverview.isBeneficiaryAction === 1">{{ (custStepOverview.assignToBeneficiaryName) ? custStepOverview.assignToBeneficiaryName : (custStepOverview.assignToEmployeeName)? custStepOverview.assignToEmployeeName : '--' }}</label>
                  </div>
                </div>
              </ng-template>
            </p-timeline>
          </ng-template>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>
  <div class="col-5">
    <h4>Petition Status</h4>
    <div class="position-relative mt-4">
      <h6>Select task to view Status</h6>
      <p-dropdown inputId="tasktype" [options]="subTaskList" [(ngModel)]="selectedTaskTypeCode" class="w-50"
        placeholder="Select Task Type" optionLabel="taskTypeName" optionValue="taskTypeCode"
        (onChange)="getStatusMap()"></p-dropdown>
      <p-chart responsive="false" type="doughnut" [data]="chartData" [options]="chartOption" class="piechart"></p-chart>
        <h2 *ngIf="statusPercentageMap" class="d-inline-block position-absolute" [ngClass]="{'text-primary': selectedChartDataFlag === 'Pending', 'text-success': selectedChartDataFlag === 'Completed',  'text-secondary': selectedChartDataFlag === 'Not Started' }" style="top: 57%;left: 35%;">{{ statusPercentageMap[selectedChartDataFlag] }}%
        </h2>
    </div>
  </div>
</div>
</div>

<div *ngIf="toggleStatus === 'externalLinks'" class="pt-2">
   <lib-external-links [inputData]="{fromBenProfile:false,fromTask: true}"></lib-external-links>
</div>

<div *ngIf="toggleStatus === 'requestDataDocuments'" class="container-fluid p-0">
  <div class="row col-md-12 p-0">
    <!-- <app-request-data-documents [isBeneficiaryQuestionnaire]="true" [beneficiaryQuestionnaireEdit]="viewDataLogData" [viewDataLog]="true" [taskLevelData]="true"></app-request-data-documents>  -->

    <app-request-data-documents class="w-100" [beneficiaryData]="beneficiaryDetails" [taskLevelData]="taskLevelData"></app-request-data-documents>

  </div>
</div>
<div *ngIf="toggleStatus === 'dataLog'" class="container-fluid p-0">
  <div class="row col-md-12 p-0">
    <app-data-log [dataLogChanges]="dataLogStatus" class="w-100"></app-data-log>
  </div>
</div>

<p-dialog header="Update Petition Details" [(visible)]="displayDialog" modal="true">
  <hr class="mt-0" />
  Before you begin to Build the RFE Response please <br />
  upload the Filled Petition Document and the documents related to your filing.
  <hr />
</p-dialog>
<router-outlet></router-outlet>